import { useCallback, useState } from 'react';

const DEFAULT_STATE = {
  isOpen: false,
  title: '',
  message: '',
  type: 'info'
};

export const useFeedbackModal = () => {
  const [modal, setModal] = useState(DEFAULT_STATE);

  const openModal = useCallback((payload) => {
    setModal({
      ...DEFAULT_STATE,
      ...payload,
      isOpen: true
    });
  }, []);

  const closeModal = useCallback(() => {
    setModal(prev => ({ ...prev, isOpen: false }));
  }, []);

  return { modal, openModal, closeModal };
};

